<!--
 * @Author: hewj hewj@cloudcc.com
 * @Date: 2022-09-19 17:16:34
 * @LastEditors: hewj hewj@cloudcc.com
 * @LastEditTime: 2022-09-20 10:28:56
 * @FilePath: \lightning-web\src\views\thirdPartyAuth\views\errorPageAuth\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="authorization">
    <div>
      <div class="logo">
        <img src="./img/logo.svg" />
      </div>
      <div class="authorization-title">
        <h2>
          <!-- 授权时出现问题 -->
          {{ $t('c2215') }}
        </h2>
      </div>
      <div class="authorization-content">
        <el-card class="box-card">
          <h4>
            <!-- 我们无法让您授权，因为出现了一下错误，有关更多信息，请联系您的cloudcc管理员 -->
            {{ $t('c2216') }}
          </h4>
          <div>
            {{ returnInfo }}
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
// 报错页面
export default {
  name: "authorization",
  data() {
    return {
      returnInfo: "",
    };
  },
  mounted() {
    // 隐藏加载框
    document.getElementById("lightning-loading").style.display = "none";
    this.init();
  },
  methods: {
    init() {
      let url = window.location.href;
      // 截取问号后面的部分  state=111&auto=true
      let searchUrl = url.split("?")[1];
      // 将url解析成对象的形式 {state: '111', auto: 'true'}
      let paramsObj = this.$qs.parse(searchUrl);
      this.returnInfo = paramsObj.returnInfo;
    },
  },
};
</script>

<style scoped lang="scss">
.authorization {
  width: 100%;
  height: 100vh;
  background: rgba(245, 246, 249, 0.48);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ul,
  li {
    list-style-type: disc;
  }
  .logo {
    width: 100%;
    display: flex;
    justify-content: center;
    img {
      width: 300px;
    }
  }
  .authorization-title {
    display: flex;
    justify-content: center;
    text-align: center;
  }
  .authorization-content {
    width: 100%;
    display: flex;
    justify-content: center;
    .box-card {
      width: 400px;
    }
  }
}
</style>
